import { render, staticRenderFns } from "./pharmaScribe.vue?vue&type=template&id=37f47af8"
import script from "./pharmaScribe.vue?vue&type=script&lang=js"
export * from "./pharmaScribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports